import { Button, Input, Typography } from "antd";
import axios, { formToJSON } from "axios";
import { AppConstants, CustomHeaderToken, GetWebServiceUrl } from "../utils/constants";
import NotificationHeader, { SetNotificationWithoutDismiss } from "../utils/notification";
import { useCookies } from "react-cookie";
import { useState } from "react";
const { Text, Link } = Typography;
const { TextArea } = Input;

async function save(cando, cache, onEnd) {
    console.log("EDIT",  cando)
    let request = {
        "cando_link": cando,
    }

    console.log(request)
    let response = await axios.post(GetWebServiceUrl(AppConstants.GENERATE), request, CustomHeaderToken(cache.access_token)).catch(err => {
        console.log("ERR", err)
        if (err.response === undefined){
            return
        }
        SetNotificationWithoutDismiss("Error", err.response.status + "\n" + JSON.stringify(err.response.data.message), "danger");
    })
    onEnd(response.data)
    return response;
}




export default function GenerateLinkContent() {
    const [cookies, setCookie] = useCookies(['access_token'])
    const [cando, setCando] = useState({})
    const [link, setLink] = useState()

    return (
        <>
            <NotificationHeader></NotificationHeader>

            <div style={{ width: "50%", margin: "auto", padding: "10px", fontFamily: "Vazirmatn" }}>
                <h1>مشخصات</h1>
                <Input
                    addonAfter='آدرس کندو'
                    style={{ padding: "10px" }}

                    placeholder=''
                    autoSize={{ minRows: 1, maxRows: 100 }}
                    onChange={
                        (e) => {
                            console.log(e.target.value);
                            setCando(e.target.value);
                        }}
                />
            </div>
            <div>
                <Button type="primary" onClick={() => {
                    save(cando, cookies, setLink)
                }}>بساز</Button>
            </div>
            <div style={{ padding: "25px" }}>
                <Text onClick={() => {
                    SetNotificationWithoutDismiss(":کپی شد", link, "success");
                    navigator.clipboard.writeText(link)
                }} copyable>{link}</Text>
            </div>
        </>

    )
}